import type { VfsPortSerializedError } from '@mimir/common/types/ipcVfs';

type NodeErrorLike = Error & {
  code?: string;
  errno?: number;
  syscall?: string;
};

export function serializeVfsPortError(ex: unknown): VfsPortSerializedError {
  if (ex instanceof Error) {
    const sys = ex as NodeErrorLike;
    return {
      message: ex.message,
      code: sys.code,
      errno: sys.errno,
      syscall: sys.syscall,
    };
  }
  return {
    message: String(ex),
    code: undefined,
    errno: undefined,
    syscall: undefined,
  };
}

export function reconstructVfsPortError(serialized: VfsPortSerializedError): Error {
  // Node's fs errors are plain Error instances with SystemError-like properties
  // attached, so a bare new Error(...) reproduces the desired shape.
  const error = new Error(serialized.message) as NodeErrorLike;
  if (serialized.code !== undefined) {
    error.code = serialized.code;
  }
  if (serialized.errno !== undefined) {
    error.errno = serialized.errno;
  }
  if (serialized.syscall !== undefined) {
    error.syscall = serialized.syscall;
  }
  return error;
}
